import { axiosInstance } from ".";

export const registerAdmin = async (token, user) => {
  try {
    const result = await axiosInstance.post("admin/register", user);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const loginUser = async (user) => {
  try {
    const result = await axiosInstance.post("super/admin/login", user);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getUser = async (token) => {
  try {
    const result = await axiosInstance.get("admin/profile/detail");
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateUser = async (token, values) => {
  try {
    const result = await axiosInstance.post("admin/profile/update", values);
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updatePassword = async (token, values) => {
  try {
    const result = await axiosInstance.post(
      "admin/profile/update/password",
      values,
    );
    return result.data;
  } catch (error) {
    return error.response.data;
  }
};
